import Papa from "papaparse";

const validEmailHeader = (result: any) => {
  return result.some(item => "email" in item);
};

export const readCSVContent = (file: File): Promise<any> => {
  return new Promise(resolve => {
    const reader = new FileReader();

    reader.onload = e => {
      try {
        let csvContent: any = e.target?.result;

        csvContent = csvContent.replace(/"/g, "");
        csvContent = csvContent.replace(/\r?\n(?![^,])/g, "");

        Papa.parse(csvContent, {
          header: true,
          dynamicTyping: true,
          skipEmptyLines: true,
          complete: (results: { errors: string | any[]; data: any }) => {
            if (results.errors.length) {
              console.error("Error parsing CSV:", results.errors);
              resolve(undefined);
            } else {
              if (validEmailHeader(results.data)) {
                resolve(results.data);
              } else {
                resolve(undefined);
              }
            }
          },

          error: (error: any) => {
            console.error("Error parsing CSV:", error);
            resolve(undefined);
          },
        });
      } catch (error) {
        console.error("Error parsing CSV:", error);
        resolve(undefined);
      }
    };

    reader.onerror = error => {
      console.error("Error parsing CSV:", error);
      resolve(undefined);
    };

    reader.readAsText(file);
  });
};
